import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './common/login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { SideNavComponent } from './common/side-nav/side-nav.component';
import { SearchGridComponent } from './common/search-grid/search-grid.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'klusup',
    component: SideNavComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      { path: 'searchresults', component: SearchGridComponent },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./components/dashboard/dashboard.module').then(
            (m) => m.DashboardModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'accounting',
        loadChildren: () =>
          import('./components/accounting/accounting.module').then(
            (m) => m.AccountingModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'itdepartment',
        loadChildren: () =>
          import('./components/itdepartment/itdepartment.module').then(
            (m) => m.ItdepartmentModule,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'booking',
        loadChildren: () =>
          import('./components/booking/booking.module').then(
            (m) => m.BookingModule,
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
